// extracted by mini-css-extract-plugin
export default {"main":"dashshared_main__lGPgD","topbar":"dashshared_topbar__53KoZ","content":"dashshared_content__38OGg","bell":"dashshared_bell__Q5UL5","toggle":"dashshared_toggle__kchOp"};